import React, { useEffect } from 'react';
import { Card, Modal, Col, Row, Typography, Button, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import './AiModel.css';

const { Title, Paragraph } = Typography;

const AiModel = ({ visible, modelData, onClose }) => {
    // 调试：看看props有没有传进来
    useEffect(() => {
        console.log('AiModel props:', { visible, modelData });
    }, [visible, modelData]);

    // 如果没有modelData，显示加载状态或空内容
    if (!modelData) {
        return null;
    }

    // Antd 5.x 必须用 open，不能用 visible
    return (
        <Modal
            title={`🚀 AI体验区 - ${modelData?.img_title || 'AI模型详情'}`}
            open={visible}
            onCancel={onClose}
            footer={null}
            width={1000}
            zIndex={10000}
            maskClosable={false}
            destroyOnClose={true}
            centered
            styles={{
                body: {
                    padding: '10px 20px 20px 20px',
                    backgroundColor: '#f5f5f5',
                    borderRadius: '0 0 8px 8px',
                    height: 'calc(100vh - 156px)', // 改为height，让body占满固定高度
                    overflowY: 'hidden'
                }
            }}
        >
            {/* 使用flex布局，确保内容不超出 */}
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%', // 改为100%，占满整个body
                gap: '12px'
            }}>
                {/* 模型描述 - 固定高度区域 */}
                <div>
                    <Title level={5} style={{ color: '#1890ff', marginBottom: '4px' }}>
                        模型描述
                    </Title>
                    <Paragraph style={{
                        fontSize: '13px',
                        color: '#666',
                        backgroundColor: '#fff',
                        padding: '8px 12px',
                        borderRadius: '6px',
                        border: '1px solid #e8e8e8',
                        marginBottom: 0,
                        lineHeight: '1.5',
                        maxHeight: '60px',
                        overflowY: 'auto'
                    }}>
                        {modelData?.img_desc || '暂无描述信息'}
                    </Paragraph>
                </div>

                <div style={{
                    flex: 1, // 占满剩余空间
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0 // 防止flex溢出
                }}>
                    {/* 特性展示区域 - 网格布局，自动适应高度 */}
                    <Row gutter={[12, 12]} justify="space-between" align="stretch" style={{flexShrink: 0, marginTop: 0}}>
                        <Col span={6}>
                            <Card hoverable style={{ width: 210, textAlign:'center' }} cover={<img alt="example" src="https://os.alipayobjects.com/rmsportal/QBnOOoLaAfKPirc.png" />}>
                                <Upload>
                                    <Button icon={<UploadOutlined />}>上传图片</Button>
                                </Upload>
                            </Card>
                        </Col>

                        <Col span={1} style={{display: 'flex',
                            alignItems: 'center',  // 垂直居中
                            justifyContent: 'center' // 水平居中（可选）
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', color: '#1890ff', fontWeight: 'bold' }}>
                                VS
                            </div>
                        </Col>

                        <Col span={6}>
                            <Card hoverable style={{ width: 210, textAlign:'center' }} cover={<img alt="example" src="https://os.alipayobjects.com/rmsportal/QBnOOoLaAfKPirc.png" />}>
                                <Upload>
                                    <Button icon={<UploadOutlined />}>上传图片</Button>
                                </Upload>
                            </Card>
                        </Col>

                        <Col span={4} style={{
                            display: 'flex',
                            alignItems: 'center',  // 垂直居中
                            justifyContent: 'center' // 水平居中（可选）
                        }}>
                            <Button type="primary">进行比对>></Button>
                        </Col>

                        <Col span={6}>
                            <div className="comparison-result-card">
                                <div>结果信息</div>
                                <div style={{ borderTop: '1px dashed #e8e8e8', paddingTop: '12px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                                        <span style={{ color: '#666' }}>相似度:</span>
                                        <span style={{ color: '#52c41a', fontWeight: 'bold' }}>100%</span>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                                        <span style={{ color: '#666' }}>差异点:</span>
                                        <span style={{ color: '#fa8c16' }}>0处</span>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <span style={{ color: '#666' }}>对比结果:</span>
                                        <span style={{ color: '#1890ff' }}>高度匹配 ✓</span>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </Modal>
    );
};

export default AiModel;
